import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {I18nDictionaryComponent} from '../../../shared/components/i18n-dictionary/i18n-dictionary.component';
import {AuthError} from '../../models/auth-error';

@Component({
    selector: 'app-password-reset-form',
    templateUrl: './password-reset-form.component.html',
    styleUrls: ['./password-reset-form.component.scss']
})
export class PasswordResetFormComponent {
    readonly confirmPasswordPlaceholderTextId = 'confirm-password-placeholder';
    readonly passwordPlaceholderTextId = 'password-placeholder';
    readonly contactHrefSubjectTextId = 'contact-href-subject';
    readonly contactHrefBodyTextId = 'contact-href-body';

    readonly minPasswordLength = 8;

    constructor() {
    }

    @Input()
    resetError: AuthError;

    @Input()
    resetSuccessful: boolean;

    @Input()
    set pending(isPending: boolean) {
        this.isPending = isPending;
        if (isPending) {
            this.form.disable();
        } else {
            this.form.enable();
        }
    }

    isPending = false;

    @Output()
    reset = new EventEmitter<{ password: string }>();

    @ViewChild(I18nDictionaryComponent, {static: true})
    i18nDictionary: I18nDictionaryComponent;

    // validation
    form: FormGroup = new FormGroup({
        password: new FormControl('', [
            Validators.pattern(
                // Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&#+~)(=/"^°<>§]{8,}$/
            ),
            Validators.required
        ]),
        confirmPassword: new FormControl('', [
            Validators.required
        ])
    }, {
        validators: [this.match('password', 'confirmPassword')]
    });

    match(controlName: string, checkControlName: string): ValidatorFn {
        return (controls: AbstractControl) => {
            const control = controls.get(controlName);
            const checkControl = controls.get(checkControlName);

            if (checkControl.errors && !checkControl.errors.mismatch) {
                return null;
            }

            if (control.value !== checkControl.value) {
                controls.get(checkControlName).setErrors({mismatch: true});
                return {mismatch: true};
            } else {
                return null;
            }
        };
    }

    get passwordControl() {
        return this.form.get('password');
    }

    get confirmPasswordControl() {
        return this.form.get('confirmPassword');
    }

    submit() {
        if (this.form.valid) {
            this.reset.emit(this.form.value);
        }
    }

}
